import { Grid } from '@mui/material';
import { ManagerAutoCompleteDataModel } from 'components/MprcAutoComplete/AutoCompleteDataModel';
import { MprcSwitch } from 'components/MprcSwitch';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ManagerAutoComplete } from 'views/foundation/user/components/ManagerAutoComplete';

////////////////////////////////////////////////////////////////////////////

interface IProps {
    onError: (e: any) => void;
    onItemsChange: (members: string[]) => void;
}
////////////////////////////////////////////////////////////////////////////

export const AddSubordinates: React.FC<IProps> = (props) => {

    const { onItemsChange, onError } = props;
    const { t } = useTranslation("knowledge");
    const [selectedItem, setSelectedItem] = useState<ManagerAutoCompleteDataModel>();
    const [includeIndirect, setIncludeIndirect] = useState<boolean>(false);

    ////////////////////////////////////////////////////////////////////////////

    ///
    const onChange = (item: ManagerAutoCompleteDataModel[]) => {
        if (item.length > 0) {
            setSelectedItem(item[0]);
        }
        else {
            setSelectedItem(undefined);
        }
    };

    ////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        onItemsChange(selectedItem
            ? includeIndirect
                ? [selectedItem.allSubordinatesGroup.id]
                : [selectedItem.directSubordinatesGroup.id]
            : []);

    }, [selectedItem, includeIndirect]);

    return <Grid container spacing={2} direction="column" sx={{ minHeight: 150 }}>
        <Grid>
            <ManagerAutoComplete
                autoFocus
                selectedItems={selectedItem ? [selectedItem] : []}
                multiSelect={true}
                onChange={onChange}
                onError={onError}
                placeholder={t("Channel.Edit.Members.ManagerPlaceholder")}
            />
        </Grid>
        <Grid>
            <MprcSwitch
                label={t("Channel.Edit.Members.IncludeIndirectsLabel")}
                helperText={t("Channel.Edit.Members.IncludeIndirectsHint")}
                checked={includeIndirect}
                onChange={() => setIncludeIndirect(!includeIndirect)}
            />
        </Grid>
    </Grid>;
};
